import React, {useEffect} from "react";
import {useTheme} from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import moment from "moment";
import clsx from "clsx";

export const colorsProportionTable = (theme, props) => {
    if (props.renderWithBG) {
        return [
            // { valueFrom: 0, color: theme.palette.info.main, colorText: theme.palette.info.contrastText },
            // { valueFrom: 75, color: theme.palette.warning.main, colorText: theme.palette.warning.contrastText },
            // { valueFrom: 90, color: theme.palette.error.main, colorText: theme.palette.error.contrastText },
            { valueFrom: 0, color: theme.palette.patientCard.green.background, colorText: theme.palette.patientCard.green.color },
            { valueFrom: 50, color: theme.palette.patientCard.yellow.background, colorText: theme.palette.patientCard.yellow.color },
            { valueFrom: 75, color: theme.palette.patientCard.red.background, colorText: theme.palette.patientCard.red.color },
            { valueFrom: 100, color: theme.palette.patientCard.burgundy.background, colorText: theme.palette.patientCard.burgundy.color },
        ];
    } else {
        return [
            // {valueFrom: 20, color: theme.palette.info.main},
            // {valueFrom: 50, color: "#70AE98"},
            // {valueFrom: 75, color: "#ECBE7A"},
            // {valueFrom: 90, color: "#A02C2D"},
            { valueFrom: 0, color: theme.palette.patientCard.green.background, colorText: theme.palette.patientCard.green.color },
            { valueFrom: 50, color: theme.palette.patientCard.yellow.background, colorText: theme.palette.patientCard.yellow.color },
            { valueFrom: 75, color: theme.palette.patientCard.red.background, colorText: theme.palette.patientCard.red.color },
            { valueFrom: 100, color: theme.palette.patientCard.burgundy.background, colorText: theme.palette.patientCard.burgundy.color },
        ];
    }
};

export const useStyles = makeStyles((theme) => ({
    timeValueFormattedSimple: {
        height: 16,
        lineHeight: "16px",
        padding: "1px 4px 0",
        fontSize: 9,
        backgroundColor: color => color.color,
        color: color => color.colorText,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    timeValueFormattedBG: {
        textTransform: "uppercase",
        backgroundColor: color => color.color,
        color: color => color.colorText,
    },
    timeValueFormatted: {
        textTransform: "uppercase",
        color: color => color.color
    }
}));

function TimerCountUp(props) {
    const [timeFormatted, setTimeFormatted] = React.useState("");
    const [proportion, setProportion] = React.useState("");

    const theme = useTheme();
    let color = undefined;
    for (let cpt of colorsProportionTable(theme, props)) {
        if (proportion > cpt.valueFrom) {
            color = cpt;
        }
    }
    const classes = useStyles(color);

    useEffect(() => {
        const pwz = v => {
            return String(v).padStart(2, '0');
        };

        const buildLabel = () => {
            if (props.time) {
                const m = moment(props.time);
                let duration;
                if(props.countDown){
                    duration = moment.duration(m.diff(moment()));
                } else if(props.countDownSince){
                    duration = moment.duration(moment(props.countDownSince).diff(m));
                } else if (props.timeTo) {
                    duration = moment.duration(moment(props.timeTo).diff(m));
                } else {
                    duration = moment.duration(moment().diff(m));
                }
                let catchLimit;
                if(props.countDown){
                    catchLimit = props.upperLimit > 0 && duration.asMinutes() < props.limit;
                } else {
                    catchLimit = props.upperLimit > 0 && duration.asMinutes() > props.limit;
                }
                if (catchLimit) {
                    setTimeFormatted(props.limitMessage);
                    if(props.countDown) {
                        setProportion(0);
                    } else {
                        setProportion(100);
                    }
                    if(props.catchLimit){
                        props.catchLimit({event: "catchLimit"});
                    }
                } else {
                    // let hours = duration.asHours();
                    // let hours = duration.hours();
                    // let minutes = duration.minutes();
                    // let seconds = duration.seconds();

                    let seconds = Math.floor(duration.asSeconds());
                    let minutes = Math.floor(seconds / 60.0);
                    seconds -= minutes * 60;
                    let hours = Math.floor(minutes / 60.0);
                    minutes -= hours * 60;

                    // console.log(duration);
                    // console.log(props.time)

                    const durationProportion = duration.asMinutes() * 100.0 / props.limit;
                    if(props.countDown) {
                        setProportion(100 - durationProportion);
                    } else {
                        setProportion(durationProportion);
                    }


                    if (props.withoutHours) {
                        setTimeFormatted(`${pwz(minutes)}:${pwz(seconds)}`)
                    } else {
                        setTimeFormatted(`${pwz(hours)}:${pwz(minutes)}:${pwz(seconds)}`)
                    }
                    if(props.countDown && (hours < 0 || minutes < 0 || seconds < 0 || hours + minutes + seconds == 0 )){
                        //console.log("catch limit : ", props.countDown, hours, minutes, seconds);
                        if(props.catchLimit) {
                            props.catchLimit({event: "timesUp"});
                        }
                    }
                    // setTimeFormatted(`${pwz(hours)}:${pwz(minutes)}:${pwz(seconds)} ---- ${durationProportion}`);
                }
            }
        };

        const iid = setInterval(buildLabel, 1000); // maybe more?
        buildLabel();

        return () => {
            clearInterval(iid);
        }
    }, [props.limit, props.limitMessage, props.time]);

    if (props.renderWithBG) {
        return (
            <div className={clsx(classes.timeValueFormattedBG, "timer-count-up")}>
                {timeFormatted}
            </div>
        );
    } else {
        return (
            <div className={clsx(classes.timeValueFormatted, "timer-count-up")}>
                {timeFormatted}
            </div>
        )
    }
}

function TimerCountUpSimple(props) {
    const [timeFormatted, setTimeFormatted] = React.useState("");
    const [proportion, setProportion] = React.useState("");

    // const classes = useStyles(proportion, { renderWithBG: true })();
    const theme = useTheme();
    let color = undefined;
    if (!props?.edau) {
        for (let cpt of colorsProportionTable(theme, { renderWithBG: true })) {
            if (proportion >= cpt.valueFrom) {
                color = cpt;
            }
        }
    } else {
        color = {
            color: "#3c78d8",
            colorText: "#fff"
        }
    }
    const classes = useStyles(color);

    useEffect(() => {
        const pwz = v => {
            return String(v).padStart(2, '0');
        };

        const buildLabel = () => {
            if (props.time) {
                const m = moment(props.time);
                let duration;
                if(props.countDownSince){
                    duration = moment.duration(moment(props.countDownSince).diff(m));
                } else {
                    duration = moment.duration(moment().diff(m));
                }
                if (props.upperLimit > 0 && duration.asMinutes() > props.upperLimit) {
                    setTimeFormatted(props.limitMessage);
                    setProportion(100);
                } else {
                    // let hours = duration.asHours();
                    // let hours = duration.hours();
                    let minutes = Math.floor(duration.asMinutes());
                    let hours = Math.floor(minutes / 60.0);
                    minutes -= hours * 60;

                    // let seconds = duration.seconds();
                    // console.log(duration);
                    // console.log(props.time)

                    const durationProportion = duration.asMinutes() * 100.0 / props.limit;
                    setProportion(durationProportion);

                    setTimeFormatted(`${pwz(hours)}:${pwz(minutes)}`);
                }
            }
        };

        const iid = setInterval(buildLabel, 10000); // maybe more? (10 sek)
        buildLabel();

        return () => {
            clearInterval(iid);
        }
    }, [props.limit, props.limitMessage, props.time, props.countDownSince, props.upperLimit]);

    return (
        <div className={clsx(classes.timeValueFormattedSimple, "timer-count-up")}>
            {timeFormatted}
        </div>
    );
}

export {
    TimerCountUp,
    TimerCountUpSimple
};
